export default {
  isLoggedIn: (state) =>
    {
      if(state.token) {
        return true;
      }
      else {
        return false;
      }
    },
    getMmCreateAccountData: (state) => {
      if (state.create_account_data) {
        return state.create_account_data;
      } else {
        return false;
      }
    },
    getSearchAccount: (state) => {
      if (state.search_accounts) {
        return state.search_accounts;
      } else {
        return false;
      }
    },
    getSearchEnterprise: (state) => {
      if (state.search_enterprises) {
        return state.search_enterprises;
      } else {
        return false;
      }
    },
    getSearchLocations: (state) => {
      if (state.search_enterprise_locations) {
        return state.search_enterprise_locations;
      } else {
        return false;
      }
    },
    getUserLocations: (state) => {
      if (state.user_locations) {
        return state.user_locations;
      } else {
        return false;
      }
    },  
    getSearchPurchasingHistory: (state) => {
      if (state.search_enterprise_purchasing_history) {
        return state.search_enterprise_purchasing_history;
      } else {
        return false;
      }
    },
  //authStatus: (state) => { return state.status; },
}



// WEBPACK FOOTER //
// ./src/store/getters.js